import {
  GET_MANAGE_WORK,
  UPDATE_MANAGE_WORK,
  DELETE_MANAGE_WORK,
  ADD_MANAGE_WORK,
} from "../type";
import { InsertDataWithImage } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import { InsUpdateData } from "../../Hooks/UpdataData";
import DeleteData from "../../Hooks/DeleteData";
export const CreateManageWorkAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertDataWithImage(`/api/AdminWorkManagement`, data);
    dispatch({
      type: ADD_MANAGE_WORK,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: ADD_MANAGE_WORK,
      payload: "Error" + e,
    });
  }
};
export const GetAllManageWorkAction = (quary) => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/AdminWorkManagement?${quary}`);
    dispatch({
      type: GET_MANAGE_WORK,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GET_MANAGE_WORK,
      payload: "Error" + e,
    });
  }
};
export const UpdateManageWorkAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/AdminWorkManagement`, body);
    dispatch({
      type: UPDATE_MANAGE_WORK,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATE_MANAGE_WORK,
      payload: "Error" + e,
    });
  }
};

export const DeleteManageWorkAction = (Id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/AdminWorkManagement?id=${Id}`);
    dispatch({
      type: DELETE_MANAGE_WORK,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETE_MANAGE_WORK,
      payload: "Error" + e,
    });
  }
};
